import { Component, Input } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { NzSelectPlacementType } from 'ng-zorro-antd/select';

@Component({
  selector: 'app-input-datepicker',
  templateUrl: './input-datepicker.component.html',
  styleUrls: ['./input-datepicker.component.scss'],
})
export class InputDatepickerComponent {
  @Input() placeholder: string = 'Select a date';
  @Input() isDisabled: boolean = false;
  @Input() label: string = '';
  @Input() control: FormControl = new FormControl();

  @Input() size: 'default' | 'large' | 'small' = 'small';
  @Input() placement: NzSelectPlacementType = 'topLeft';

  isRequired(control: AbstractControl | null): boolean {
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'] ? true : false;
  }
}
